import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription, IdDescriptionCollection } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductTypeReference');
  }

  getForCustomerOrder(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/CustomerOrder`);
  }

  getSpecProductTypes(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/SpecProductTypes`);
  }

  getWithCollectionFlag(): Observable<IdDescriptionCollection[]> {
    return this.httpService.get<IdDescriptionCollection[]>(`${this.apiUrl}/WithCollectionFlag`);
  }
}
